// hooks/useSuccess.ts
import { message } from "antd";

export const useSuccess = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const showSuccess = (texto: string | undefined) => {
    messageApi.open({
      type: "success",
      content: texto,
      key: "success",
    });
  };

  return { showSuccess, contextHolder };
};
